import {
  FaClock,
  FaDollarSign,
  FaUserPlus,
  FaChartBar,
  FaFileAlt,
  FaCalendarAlt,
  FaAward,
  FaExclamationCircle,
  FaShieldAlt,
} from "react-icons/fa";

export const featuresData = [
  {
    icon: FaClock,
    title: "featuresSection.attendance.title",
    description: "featuresSection.attendance.desc",
  },
  {
    icon: FaDollarSign,
    title: "featuresSection.payroll.title",
    description: "featuresSection.payroll.desc",
  },
  {
    icon: FaUserPlus,
    title: "featuresSection.hiring.title",
    description: "featuresSection.hiring.desc",
  },
  {
    icon: FaChartBar,
    title: "featuresSection.performance.title",
    description: "featuresSection.performance.desc",
  },
  {
    icon: FaFileAlt,
    title: "featuresSection.requests.title",
    description: "featuresSection.requests.desc",
  },
  {
    icon: FaCalendarAlt,
    title: "featuresSection.meetings.title",
    description: "featuresSection.meetings.desc",
  },
  {
    icon: FaAward,
    title: "featuresSection.rewards.title",
    description: "featuresSection.rewards.desc",
  },
  {
    icon: FaExclamationCircle,
    title: "featuresSection.penalties.title",
    description: "featuresSection.penalties.desc",
  },
  {
    icon: FaShieldAlt,
    title: "featuresSection.access.title",
    description: "featuresSection.access.desc",
  },
];